import soyabeanOil from "../assets/products/mahakosh.jpg";
import soyabeanOilFortune from "../assets/products/fotune.jpg";
import arharDal from "../assets/products/arhar-dal.png";
import lalMasoor from "../assets/products/lal-masoor.jpg";
import sugardouble from "../assets/products/chini-double.jpg";
import peanuts from "../assets/products/bhuni-moongfali.jpg";
import flour from "../assets/products/manvya-atta.jpg";
import ashirvadflour from "../assets/products/ashirvad-atta.jpg";
import flour555 from "../assets/products/555-atts.jpg";
import chawalatta from "../assets/products/chawa-atta.jpg";
import bajraatta from "../assets/products/bajra-atta.jpg";
import mustardOil from "../assets/products/bharat-oil.jpg";
import ashirvadmustardOil from "../assets/products/ashirvasd-oil.jpg";
import soapghari from "../assets/products/ghari-soap.jpg";
import soaprin from "../assets/products/rin-soap.jpg";
import soapvim from "../assets/products/vim-set.jpg";
import butterpaper from "../assets/products/bp-25.jpg";

export const products = [
  {
    id: 1,
    name: "Mahakosh Soyabean Refined Oil",
    price: 115,
    category: "Oil",
    shortDescription: "High-quality refined soybean oil",
    description: "Premium Mahakosh Soyabean Refined Oil, 1 liter bottle. Perfect for cooking and frying with a light taste and high smoke point.",
    image: soyabeanOil
  },
  {
    id: 2,
    name: "Fortune Soyabean Refined Oil",
    price: 130,
    category: "Oil",
    shortDescription: "High-quality refined soybean oil",
    description: "Premium Fortune Soyabean Refined Oil, 1 liter bottle. Perfect for cooking and frying with a light taste and high smoke point.",
    image: soyabeanOilFortune
  },
  {
    id: 3,
    name: "Arhar Dal 1kg",
    price: 120,
    category: "Pulses",
    shortDescription: "High-quality Arhar dal",
    description: "Premium Arhar dal, 1 kilogram pack. Cleaned and sorted for the best quality and taste.",
    image: arharDal
  },
  {
    id: 4,
    name: "Lal Masoor Dal 1kg",
    price: 90,
    category: "Pulses",
    shortDescription: "High-quality Lal Masoor dal",
    description: "Premium Lal Masoor dal, 1 kilogram pack. Cleaned and sorted for the best quality and taste.",
    image: lalMasoor
  },
  
  {
    id: 6,
    name: "Chini double filter 1 kg",
    price: 47,
    category: "Sugar",
    shortDescription: "High-quality double filter sugar",
    description: "Premium Chini double filter sugar, 1 kilogram pack. Pure and refined for your daily use.",
    image: sugardouble
  },
  {
    id: 7,
    name: "Bhuni Moongfali 1kg",
    price: 100,
    category: "staples",
    shortDescription: "Bhuni Moongfali 1kg",
    description: "Premium Bhuni Moongfali, 1 kilogram pack. Roasted peanuts with a rich flavor, perfect for snacking and cooking.",
    image: peanuts
  },
  {
    id: 8,
    name: "Makka Atta 1kg",
    price: 50,
    category: "staples",
    shortDescription: "High-quality Makka Atta",
    description: "Premium Makka Atta, 1 kilogram pack. Perfect for making traditional Indian flatbreads with a rich corn flavor.",
    image: flour
  },
  {
    id: 9,
    name: "Bajra Atta 1kg",
    price: 50,
    category: "staples",
    shortDescription: "High-quality Bajra Atta",
    description: "Premium Bajra Atta, 1 kilogram pack. Perfect for making traditional Indian flatbreads with a rich millet flavor.",
    image: bajraatta
  },
  {
    id: 10,
    name: "Chawal Atta 1kg",
    price: 50,
    category: "staples",
    shortDescription: "High-quality Chawal Atta",
    description: "Premium Chawal Atta, 1 kilogram pack. Perfect for making traditional Indian flatbreads with a rich rice flavor.",
    image: chawalatta
  },
  {
    id: 11,
    name: "Atta Manvya 10kg",
    price: 350,
    category: "staples",
    shortDescription: "High-quality Atta Manvya",
    description: "Premium Atta Manvya, 10 kilogram pack. Perfect for making traditional Indian flatbreads with a rich wheat flavor.",
    image: flour
  },
  {
    id: 12,
    name: "Atta 555 10kg",
    price: 350,
    category: "staples",
    shortDescription: "High-quality Atta 555",
    description: "Premium Atta 555, 10 kilogram pack. Perfect for making traditional Indian flatbreads with a rich wheat flavor.",
    image: flour555
  },
  {
    id: 13,
    name: "Atta handle 10kg",
    price: 320,
    category: "staples",
    shortDescription: "High-quality Atta handle",
    description: "Premium Atta handle, 10 kilogram pack. Perfect for making traditional Indian flatbreads with a rich wheat flavor.",
    image: flour
  },
  {
    id: 14,
    name: "Ashirvad Atta 10kg",
    price: 460,
    category: "staples",
    shortDescription: "High-quality Ashirvad Atta",
    description: "Premium Ashirvad Atta, 10 kilogram pack. Perfect for making traditional Indian flatbreads with a rich wheat flavor.",
    image: ashirvadflour
  },
  {
    id: 15,
    name: "Ashirvad Mustard Oil 1L",
    price: 170,
    category: "staples",
    shortDescription: "High-quality Ashirvad Mustard Oil",
    description: "Premium Ashirvad Mustard Oil, 1 liter pack. Perfect for cooking with a rich mustard flavor.",
    image: ashirvadmustardOil
  },
  {
    id: 16,
    name: "Bharat kachhi ghani Mustard Oil 1L",
    price: 165,
    category: "staples",
    shortDescription: "High-quality Bharat kachhi ghani Mustard Oil",
    description: "Premium Bharat kachhi ghani Mustard Oil, 1 liter pack. Perfect for cooking with a rich mustard flavor.",
    image: mustardOil
  },
  {
    id: 17,
    name: "ghari soap pack of 6 (mrp 10rs each)",
    price: 55,
    category: "staples",
    shortDescription: "High-quality Ghari Soap",
    description: "Pack of 6 Ghari soaps, each with an MRP of 10rs. Ideal for daily use with a refreshing fragrance.",
    image: soapghari
  },
  {
    id: 18,
    name: "Rin soap pack of 6 (mrp 10rs each)",
    price: 55,
    category: "staples",
    shortDescription: "High-quality Rin Soap",
    description: "Pack of 6 Rin soaps, each with an MRP of 10rs. Ideal for daily use with a refreshing fragrance.",
    image: soaprin
  },
  {
    id: 19,
    name: "Vim set 3 pack",
    price: 30,
    category: "soap",
    shortDescription: "High-quality Vim Soap",
    description: "Set of 3 Vim soaps, ideal for daily use with a refreshing fragrance.",
    image: soapvim
  },
  {
    id: 20,
    name: "Aluminium butter paper 25m",
    price: 100,
    category: "Accessories",
    shortDescription: "Aluminium butter paper 25m",
    description: "Premium aluminium butter paper, 25 meters long. Ideal for cooking and baking purposes.",
    image: butterpaper
  }
];
